import React, { ComponentProps } from 'react'
import CarouselLockedCardLoadingSkeleton from './CarouselLockedCardLoadingSkeleton'
import OfferCardMapper from './OfferCardMapper'
import CarouselCardMediumLoadingSkeleton from './OfferCardMedium/CarouselCardMediumLoadingSkeleton'
import CarouselCardSmallLoadingSkeleton from './OfferCardSmall/CarouselCardSmallLoadingSkeleton'

type InheritedOfferCardProps = Pick<ComponentProps<typeof OfferCardMapper>, 'variant' | 'size'>

interface Props extends InheritedOfferCardProps, React.HTMLAttributes<HTMLDivElement> {
}

function OfferCardLoadingSkeleton({ variant = 'card-default', size = 'small', ...rest }: Props) {
  if (variant === 'card-default' || variant === 'card-opaque') {
    switch (size) {
      case 'small':
        return <CarouselCardSmallLoadingSkeleton {...rest} />
      case 'medium':
        return <CarouselCardMediumLoadingSkeleton {...rest} />
    }
    return null
  }

  if (variant === 'card-locked') {
    return <CarouselLockedCardLoadingSkeleton {...rest} />
  }

  return null
}

export default OfferCardLoadingSkeleton
